/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  TbArrowBigUpLine,
  TbArrowBigUpLineFilled,
  TbArrowBigDownLine,
  TbArrowBigDownLineFilled,
} from 'react-icons/tb';
import { BiCommentDetail } from 'react-icons/bi';
import { asyncUpVoteThread, asyncDownVoteThread, asyncNeutralizeVoteThread } from '../states/threadVotes/action';

function ThreadVotes({
  id, upVotesBy, downVotesBy, totalComments, authUser,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isThreadUpVoted = upVotesBy.includes(authUser.id);
  const isThreadDownVoted = downVotesBy.includes(authUser.id);

  const onThreadClick = () => {
    navigate(`/thread/${id}`);
  };

  const onThreadPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      navigate(`/thread/${id}`);
    }
  };

  const onUpVoteThread = () => {
    dispatch(asyncUpVoteThread(id));
  };

  const onDownVoteThread = () => {
    dispatch(asyncDownVoteThread(id));
  };

  const onNeutralizedVoteThread = () => {
    dispatch(asyncNeutralizeVoteThread(id));
  };

  return (
    <section className="votes">
      <div className="thread-detail__icon">
        <button className="vote-button" type="button" aria-label="up-vote" onClick={() => (isThreadUpVoted ? onNeutralizedVoteThread() : onUpVoteThread())}>
          { isThreadUpVoted ? <TbArrowBigUpLineFilled style={{ color: '#3B6E03' }} /> : <TbArrowBigUpLine />}
        </button>
        <span>
          {upVotesBy.length}
        </span>
      </div>
      <div className="thread-detail__icon">
        <button className="vote-button" type="button" aria-label="down-vote" onClick={() => (isThreadDownVoted ? onNeutralizedVoteThread() : onDownVoteThread())}>
          { isThreadDownVoted ? <TbArrowBigDownLineFilled style={{ color: '#3B6E03' }} /> : <TbArrowBigDownLine />}
        </button>
        <span>
          {downVotesBy.length}
        </span>
      </div>
      <div className="thread-detail__icon">
        <button className="vote-button" type="button" aria-label="comment" onClick={onThreadClick} onKeyDown={onThreadPress}>
          <BiCommentDetail />
        </button>
        <span>
          {totalComments}
        </span>
      </div>
    </section>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const threadItemShape = {
  id: PropTypes.string,
  title: PropTypes.string,
  totalComments: PropTypes.number,
  body: PropTypes.string,
  category: PropTypes.string,
  createdAt: PropTypes.string,
  authUser: PropTypes.shape(userShape).isRequired,
};

ThreadVotes.propTypes = {
  ...threadItemShape,
};

export { threadItemShape };

export default ThreadVotes;
